import { render } from "./PageItemFilterEdit.vue?vue&type=template&id=5d9d056a&scoped=true"
import script from "./PageItemFilterEdit.vue?vue&type=script&lang=js"
export * from "./PageItemFilterEdit.vue?vue&type=script&lang=js"

import "./PageItemFilterEdit.vue?vue&type=style&index=0&id=5d9d056a&scoped=true&lang=scss"

import exportComponent from "/home/itube/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5d9d056a"]])

export default __exports__